import { Grid, Skeleton, Stack } from '@mui/material';

export const AdvancedTagMappingSkeleton = () => (
  <Stack sx={{ padding: '16px', paddingTop: 0 }}>
    <Grid container spacing={2} sx={{ mt: '16px' }}>
      {Array.from({ length: 9 }, (v, i) => i).map((value) => (
        <Grid key={`skeleton-${value}`} item xs={4}>
          <Skeleton animation="wave" variant="rounded" height={'56px'} />
        </Grid>
      ))}

      <Stack justifyContent="flex-end" flexDirection={'row'} sx={{ mt: 5, width: '100%' }}>
        <Skeleton
          sx={{ maxWidth: '80px', mr: 1 }}
          animation="wave"
          variant="rounded"
          height={'30px'}
          width={'80px'}
        />
        <Skeleton
          sx={{ maxWidth: '132px' }}
          animation="wave"
          variant="rounded"
          height={'30px'}
          width={'132px'}
        />
      </Stack>
    </Grid>
  </Stack>
);
